import { goto } from '$app/navigation';
import { WidgetAuthMode, type Widget, type WidgetContent } from '#lib/types/generated/index.js';
import { get, writable } from 'svelte/store';

import { deepClone } from '#lib/helper/clone.js';

export const widgetConfig = writable<Widget>();
export const widgetContent = writable<WidgetContent>();

export function clearWidgetConfig(): void {
	widgetConfig.set(undefined!);
}

let defaultWidgetContent: WidgetContent | undefined = undefined;

export function setDefaultWidgetContent(content: WidgetContent): void {
	defaultWidgetContent = deepClone(content);
	widgetContent.set(content);
}

export function getDefaultWidgetContent(): WidgetContent {
	if (!defaultWidgetContent) {
		const current = get(widgetContent);
		defaultWidgetContent = deepClone(current);
	}
	return deepClone(defaultWidgetContent);
}

export function restoreDefaultWidgetContent(): void {
	if (defaultWidgetContent) {
		widgetContent.set(deepClone(defaultWidgetContent));
	}
}

export const widgetChatEnabled = writable<boolean>(false);
export const widgetShowHeaderContactInfo = writable<boolean>(false);

export function gotoGiftcards(): void {
	goto('/widget/' + get(widgetConfig).hash + '/giftcards');
}

export function gotoPackages(): void {
	goto('/widget/' + get(widgetConfig).hash + '/packages');
}

export function gotoAuthLogin(): void {
	if (get(widgetConfig).memberArea.authMode === WidgetAuthMode.Okta) {
		goto('/widget/' + get(widgetConfig).hash + '/auth/okta');
	} else {
		goto('/widget/' + get(widgetConfig).hash + '/auth/login');
	}
}

export function gotoMemberArea(): void {
	goto('/widget/' + get(widgetConfig).hash + '/member');
}
